var map = {
	"./decidim/avatar-multiuser.png": 8747,
	"./decidim/brands/facebook.svg": 71267,
	"./decidim/brands/google.svg": 46714,
	"./decidim/brands/twitter-x.svg": 60427,
	"./decidim/cc-badge.png": 38553,
	"./decidim/decidim-logo.svg": 50137,
	"./decidim/default-avatar.svg": 88233,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 89039,
	"./decidim/icons.svg": 15496,
	"./decidim/pattern.png": 2939,
	"./decidim/placeholder-card-g.svg": 57704,
	"./decidim/placeholder-card-l.svg": 46083,
	"./decidim/placeholder.jpg": 67146,
	"./decidim/remixicon.symbol.svg": 51056,
	"./decidim/vendor/social-share-button/douban.svg": 58147,
	"./decidim/vendor/social-share-button/email.svg": 16508,
	"./decidim/vendor/social-share-button/facebook.svg": 54408,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 3948,
	"./decidim/vendor/social-share-button/hacker_news.svg": 37168,
	"./decidim/vendor/social-share-button/linkedin.svg": 37338,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 50915,
	"./decidim/vendor/social-share-button/pinterest.svg": 80842,
	"./decidim/vendor/social-share-button/reddit.svg": 64416,
	"./decidim/vendor/social-share-button/telegram.svg": 4453,
	"./decidim/vendor/social-share-button/tumblr.svg": 31810,
	"./decidim/vendor/social-share-button/twitter.svg": 95577,
	"./decidim/vendor/social-share-button/vkontakte.svg": 2291,
	"./decidim/vendor/social-share-button/wechat.svg": 96510,
	"./decidim/vendor/social-share-button/whatsapp.svg": 51862,
	"./decidim/vendor/social-share-button/x.svg": 48468,
	"./decidim/vendor/social-share-button/xing.svg": 99844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45424;